export const GridCardPlaceholder = () => (
  <div className="col-md-6 col-lg-3 col-6 my-3 align-item-stretch placeholder-glow">
    <div className="card-header-img position-relative placeholder-glow rounded-8">
      <div className="card-img-top placeholder rounded-8 bg-dark w-100" />
    </div>
    <span className="placeholder col-7 rounded-8 bg-dark d-block my-2" />
    <span className="placeholder col-3 rounded-8 bg-dark d-block my-2" />
  </div>
)
